import React, { Component, Fragment } from 'react';
import {
    LoadingComponent, PageListComponent, HeaderListComponent,
} from "../../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../../helpers/functions';
import SaleReport from '../../../../../../models/SaleReport';

import Wrapper from '../../../../common/component/Wrapper';

import { omit } from 'lodash';
import ReportList from './ReportList';

import './OrderDetailReportsBySKU.less';

let permisionActions = [];
const defaultState = {

};

export default class OrderDetailReportsBySKU extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
    }

    componentDidMount() {
        this.getSaleDetailReportsBySKU()
    }

    render() {
        const { t, hideHeader, reportState, orderState } = this.props;
        const { isFetching, saleDetailReportBySKU } = reportState;
        return (
            <PageListComponent className="page-sale-report">
                {!hideHeader &&
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'orders'}
                        titleHeader={t('item.report.orderDetailReportsBySku')}
                    />
                }
                <Wrapper className="">
                    <ReportList report={saleDetailReportBySKU}
                        loading={isFetching}
                        downloading={orderState.isFetchingDownload}
                        onChangeFilters={this.getSaleDetailReportsBySKU}
                        onExportExcel={this.onExportExcel}
                        />
                </Wrapper>
            </PageListComponent>
        );
    }

    getSaleDetailReportsBySKU = (filters) => {
        const { reportState } = this.props;
        if (!filters) filters = omit(reportState.saleDetailReportBySKU, ['items']);
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSaleDetailReportBySKU(filters);
    }

    onExportExcel = (filters) => {
        this.props.exportSkuSaleDetailExcel(filters);
    }

}

OrderDetailReportsBySKU.defaultProps = {
    hideHeader: false,
}
